import _slicedToArray from "/Users/marcinlukasik/Documents/projects/virtual-tour/admin/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
function _ref2(copied) {
  return copied;
}
function useCopy(text) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    copied = _React$useState2[0],
    setCopied = _React$useState2[1];
  var reset = React.useRef(function () {
    return setCopied(false);
  }); // Resets 'copied' if text changes

  React.useEffect(function () {
    return reset.current;
  }, [text]);
  function _ref() {
    return setCopied(true);
  }
  function _ref3() {
    return setCopied(_ref2);
  }
  return {
    copied: copied,
    copy: React.useCallback(function () {
      return copyToClipboard(text).then(_ref).catch(_ref3);
    }, [text]),
    reset: reset.current
  };
}
/* istanbul ignore next */

function copyToClipboard(text) {
  // uses the Async Clipboard API when available. Requires a secure browing
  // context (i.e. HTTPS)
  if (navigator.clipboard) return navigator.clipboard.writeText(text); // puts the text to copy into a <span>

  var span = document.createElement('span');
  span.textContent = text; // preserves consecutive spaces and newlines

  span.style.whiteSpace = 'pre'; // adds the <span> to the page

  document.body.appendChild(span); // makes a selection object representing the range of text selected by the user

  var selection = window.getSelection();
  if (!selection) return Promise.reject();
  var range = window.document.createRange();
  selection.removeAllRanges();
  range.selectNode(span);
  selection.addRange(range); // copies text to the clipboard

  try {
    window.document.execCommand('copy');
  } catch (err) {
    return Promise.reject();
  } // cleans up the dom element and selection

  selection.removeAllRanges();
  window.document.body.removeChild(span); // the Async Clipboard API returns a promise that may reject with `undefined`
  // so we match that here for consistency

  return Promise.resolve();
}
export default useCopy;